import { Component, Inject, Input, PLATFORM_ID } from "@angular/core";
import { DomainsManager } from "@core-managers/domains.manager";
import { ToastService } from "@shared-services/toast.service";
import { TranslateService } from "@shared-services/translate.service";
import { RedeemManager } from "@core-managers/redeem.manager";

@Component({
  selector: 'app-search-domain-single',
  templateUrl: './search-domain-single.component.html'
})
export class SearchDomainSingleComponent
{
  @Input({ required: false }) public showSearcher: boolean = true;
  @Input({ required: false }) public showPricesInSearch: boolean = true;
  @Input({ required: false }) public onlyTldMx: boolean = true;
  @Input({ required: false }) public buttonAddtoCartText: string = "Agregar al carrito";
  @Input({ required: false }) public title: string = "Encuentra y registra tu dominio web en Akky";
constructor(@Inject(PLATFORM_ID) private platformId,
  protected translateService: TranslateService,
  private domainsManager: DomainsManager,
  protected redeemManager: RedeemManager,
  public toast: ToastService) { }

  public onSingleSearch(): void
  {
    if (this.onlyTldMx)
    {
      this.domainsManager.searchSimpleDomainMx();
    }
    else
    {
      this.domainsManager.searchSimpleDomain();
    }
  }

  public onSearchChangeMode(): void
  {
    return;
  }
}
